export default __webpack_public_path__ + "static/media/031-goat.83f8ee64.svg";